'use strict';
exports.default = exports;

exports.name = {
  COMPANY: 'COMPANY',
  ADMIN: 'ADMIN',
  CLIENT: 'CLIENT',
  UNKNOWN: 'UNKNOWN',
};

exports.ExtraWorkspace = {
  COMPANY: {
    userDatabase: ''
  },
};

exports.defaultClaims = {
  type: {},
  rules: {},
  c: {},
  info: null,
};

/*

type: {
 cli: true,
 adm: true,
 comp: true
}
rules: {
  adm: true,    // admin
  edit: true,   // editor
  ane: true,  // anesthetist
  sur: true,  // surgeon
},
rulesC: {
  companyId1: {
    active: true,
    adm: true,    // admin
    edit: true,   // editor
    ane: true,  // anesthetist
    sur: true,    // surgeon
  }
  companyId2: {
    active: true,
    adm: true,    // admin
    edit: true,   // editor
    ane: true,  // anesthetist
    sur: true,    // surgeon
  }
},



 */


